// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-section {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    justify-items: center;
}

.blog-item {
    width: 100%;
    border: 5px solid blue;
    border-radius: 8px;
    padding: 20px;
}

.blog-item img {
    width: 100%;
    border-radius: 8px;
}

.blog-item h3 {
    margin: 10px 0;
}

.blog-item p {
    color: #555;
}

/* .blog-item button {
    margin-top: 10px;
    padding: 8px 16px;
    background-color: #6C63FF;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
} */
@media (max-width:1280px) {
    .blog-section{
        grid-template-columns: repeat(3,1fr);
    }
}
@media (max-width:1080px) {
    .blog-section{
        grid-template-columns: repeat(2,1fr);
    }
}
@media (max-width:840px) {
    .blog-section{
        grid-template-columns: repeat(2,1fr);
    }
}
@media (max-width:600px) {
    .blog-section{
        grid-template-columns: repeat(1,4fr);
    }
}

h1, h2, h3, h4, h5{
    margin-top:30px;
    margin-bottom:20px;
}
h6{
    margin-top:10px;
    margin-bottom:5px; 
}

@media (min-width: 1200px) {
    .social-media-links {
      position: fixed;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      z-index: 1000;
    }
  
    .social-media-links a {
      display: block;
      margin-bottom: 10px;
    }

    .smlink{
        display:none;
    }
  }
  
  @media (max-width: 1199px) {
    .social-media-links {
      display: none;
    }
  }`, "",{"version":3,"sources":["webpack://./src/BlogIndi/BlogIndi.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;;;;;;;;GAQG;AACH;IACI;QACI,oCAAoC;IACxC;AACJ;AACA;IACI;QACI,oCAAoC;IACxC;AACJ;AACA;IACI;QACI,oCAAoC;IACxC;AACJ;AACA;IACI;QACI,oCAAoC;IACxC;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;MACE,eAAe;MACf,QAAQ;MACR,WAAW;MACX,2BAA2B;MAC3B,aAAa;IACf;;IAEA;MACE,cAAc;MACd,mBAAmB;IACrB;;IAEA;QACI,YAAY;IAChB;EACF;;EAEA;IACE;MACE,aAAa;IACf;EACF","sourcesContent":[".blog-section {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px;\n    justify-items: center;\n}\n\n.blog-item {\n    width: 100%;\n    border: 5px solid blue;\n    border-radius: 8px;\n    padding: 20px;\n}\n\n.blog-item img {\n    width: 100%;\n    border-radius: 8px;\n}\n\n.blog-item h3 {\n    margin: 10px 0;\n}\n\n.blog-item p {\n    color: #555;\n}\n\n/* .blog-item button {\n    margin-top: 10px;\n    padding: 8px 16px;\n    background-color: #6C63FF;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n} */\n@media (max-width:1280px) {\n    .blog-section{\n        grid-template-columns: repeat(3,1fr);\n    }\n}\n@media (max-width:1080px) {\n    .blog-section{\n        grid-template-columns: repeat(2,1fr);\n    }\n}\n@media (max-width:840px) {\n    .blog-section{\n        grid-template-columns: repeat(2,1fr);\n    }\n}\n@media (max-width:600px) {\n    .blog-section{\n        grid-template-columns: repeat(1,4fr);\n    }\n}\n\nh1, h2, h3, h4, h5{\n    margin-top:30px;\n    margin-bottom:20px;\n}\nh6{\n    margin-top:10px;\n    margin-bottom:5px; \n}\n\n@media (min-width: 1200px) {\n    .social-media-links {\n      position: fixed;\n      top: 50%;\n      right: 10px;\n      transform: translateY(-50%);\n      z-index: 1000;\n    }\n  \n    .social-media-links a {\n      display: block;\n      margin-bottom: 10px;\n    }\n\n    .smlink{\n        display:none;\n    }\n  }\n  \n  @media (max-width: 1199px) {\n    .social-media-links {\n      display: none;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
